module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5thz2"))).then(() => parcelRequire('8djPr'));